import NetworkUtil from "./NetworkUtil";

export default class AdminAPI {

    public static async filterHL7Message(filter:{filter:{ReqNum}}):Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makePost("/api/admin/connect/filter", filter)
    }


}
